export type State = "open" | "closed";

export const booleanToState = (isTrue: boolean): State => (isTrue ? "open" : "closed");
export const stateToBoolean = (currentState: State) => currentState === "open";
